import { useMemo } from 'react';
import { useAdminConfig } from './useAdminConfig';
import type { AdminConfig } from '../api/admin.api';

export function useAdminPolicy() {
  const { config, loading, error } = useAdminConfig();
  const features: Partial<AdminConfig['features']> = config?.features ?? {};
  const modules: Partial<NonNullable<AdminConfig['modules']>> = config?.modules ?? {};

  return useMemo(() => {
    const isConfigReady = Boolean(config) && !loading;
    const isConfigUnavailable = !loading && !config;
    const configState = loading ? 'loading' : config ? 'ready' : 'unavailable';
    const canAccessAdmin = isConfigReady;
    const canViewForecast = canAccessAdmin && modules.forecast !== false && features.forecast !== false;
    const canRunFloriaSync = canAccessAdmin;
    const canExport = canAccessAdmin && modules.export !== false;
    const canExportXlsx = canExport && features.exportXlsx !== false;
    const canViewDiagnostics = canAccessAdmin;
    const canUseLegacyExports = canExport;

    return {
      loading,
      error,
      configState,
      isConfigReady,
      isConfigUnavailable,
      canAccessAdmin,
      canViewForecast,
      canRunFloriaSync,
      canExport,
      canExportXlsx,
      canViewDiagnostics,
      canUseLegacyExports,
      enabledModules: modules,
      enabledFeatures: features,
    };
  }, [config, loading, error, features, modules]);
}
